import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  AcceptPolicyInput,
  PolicyAcceptance,
  PolicyAcceptanceStatus,
} from '@accounting/shared';
import { api } from '../lib/api';

export function usePolicyAcceptanceStatus() {
  return useQuery({
    queryKey: ['policy-acceptances'],
    queryFn: () => api.get<PolicyAcceptanceStatus>('/me/policy-acceptances'),
  });
}

export function useAcceptPolicy() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: AcceptPolicyInput) =>
      api
        .post<{ acceptance: PolicyAcceptance }>('/me/policy-acceptances', input)
        .then((r) => r.acceptance),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['policy-acceptances'] });
    },
  });
}
